import React from 'react'
import ContactCTA from './ContactCTA'
import ContactFaq from './ContactFaq'
import ContactUss from './ContactUss'

const MainContact = () => {
  return (
    <>
    <ContactCTA/>
    <ContactFaq/>
    <ContactUss/>
    </>
  )
}

export default MainContact